<template>
  <v-dialog v-model="modal" persistent :transition="transition" :fullscreen="fullscreen" :width="width" scrollable>
    <v-card :class="blackBg?'background-m2':''">
      <boton-cerrar-modal-app @cerrar="$emit('click',false)" :mostrarCerrar="mostrarCerrar"></boton-cerrar-modal-app>
      <v-card-text>
        <v-flex contain class="dialog-content">
          <slot></slot>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  model: {
    prop: 'modal',
    event: 'click'
  },
  props: {
    modal: Boolean,
    width: {
      type: String,
      default: '500px'
    },
    fullscreen: {
      type: Boolean,
      default: true,
    },
    mostrarCerrar: {
      type: Boolean,
      default: true
    },
    blackBg: {
      type: Boolean,
      default: false
    },
    transition: {
      type: String,
      default: 'dialog-transition'
    },
  },
  data() {
    return {
    }
  },
  watch: {
    fullscreen: function(value){
      if(value){

      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-content {
  max-width: 1100px;
  // max-width: 100%;
  margin: auto;
  padding: 15px;
  align-items: center;
  @media (max-height: 800px){
    align-items: start;
  }
}

.fullscreen {
  @media (min-height: 800px){
    height: 70vh;
  }
}

.fondo-curso-modal {
  background-color: white;
  background-position: bottom;
  background-size: contain;
  background-repeat: no-repeat;
}


.background-m2 {
  background-image: url('../assets/textura-M2.png');
  background-repeat: repeat;
}
</style>
